export default __webpack_public_path__ + "assets/img/done_illustrator.c25b93e9cb5836317bd7b6a7cb9a3338.svg";